import React, { useEffect, useCallback, useRef, useState, useImperativeHandle, forwardRef } from "react";

import axios from 'util/axios';

import update from "immutability-helper";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";

const SEARCHCONDITION_PROJ = {
    code: "",
};

const Projects = (props, ref) => {
    const TBL_DATA_REF = useRef([]);
    const TBL_DATA_ORIGIN = useRef([]);

    const ALL_CHECK = useRef(null);

    useImperativeHandle(ref, () => ({
        filterProject: (data) => {
            TBL_DATA_REF.current = TBL_DATA_ORIGIN.current.filter((f) => {
                return !data.find((ff) => ff.code === f.code);
            });
            SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date().toString() }));
        },
    }));

    const [ProjList, SetProjList] = useState([]);

    const [SearchCondition, SetSearchCondition] = useState(SEARCHCONDITION_PROJ);

    const getDataList = async () => {
        const response = await axios
            .post(process.env.REACT_APP_API + "/common/retrieveMasterCodeList", {
                grcd: "PROJECT",
            })
            .then((Response) => Response?.data?.data?.result);

        TBL_DATA_ORIGIN.current = response || [];
        TBL_DATA_REF.current = [...TBL_DATA_ORIGIN.current];

        SetSearchCondition((OLD) => ({ ...OLD, refresh: new Date().toString() }));
    };

    useEffect(() => {
        getDataList();
    }, []);

    const HandleSearchCondition = (element) => {
        const name = element.target.name;
        const value = element.target.value;
        SetSearchCondition((OLD) => ({ ...OLD, [name]: value }));
    };

    const inputDelayRef = useRef(null);

    useEffect(() => {
        clearTimeout(inputDelayRef.current);
        // inputDelayRef.current = setTimeout(() => {
        const { code } = SearchCondition;
        let newData = TBL_DATA_REF.current;
        if (code) {
            newData = newData.filter((f) => {
                const regex = new RegExp("^" + code, "gi");
                return f.code.match(regex);
            });
        }
        SetProjList(newData);
        // }, 500);
    }, [SearchCondition]);

    const AllCheckFunc = (e) => {
        const check = e.target.checked;
        SetProjList((OLD) => OLD.map((e) => ({ ...e, checked: check })));
    };

    const HandleCheckbox = (checked, index) => {
        SetProjList((OLD) => {
            const NEW_DATA = update(OLD, {
                [index]: { $set: { ...OLD[index], checked: checked } },
            });
            const check = NEW_DATA.filter((f) => !f.checked);
            if (ALL_CHECK.current.checked && check.length > 0) {
                ALL_CHECK.current.checked = false;
            } else if (check.length < 1) {
                ALL_CHECK.current.checked = true;
            }
            return NEW_DATA;
        });
    };

    const HandleProjAdd = () => {
        props?.addProject && props?.addProject(ProjList.filter((f) => f.checked));
    };

    const CHECKED = ProjList.length > 0 && ProjList.filter((f) => f.checked).length === ProjList.length;
    return (
        <div
            className={"userAuthExternalTable"}
            style={{ flex: "0 0 180px", marginLeft: "100px", visibility: props.selectedUser ? "initial" : "hidden" }}
        >
            {ProjList?.filter((f) => f.checked)?.length > 0 && (
                <div className={"project-add-btn"} onClick={HandleProjAdd}>
                    <FontAwesomeIcon icon={faCirclePlus} />
                    Add
                </div>
            )}

            <div
                style={{
                    width: "170px",
                }}
            >
                <table className={"bpl-table-default fixed has-pagination userAuthExternalTable-table seleced"}>
                    <colgroup>
                        <col width="40px" />
                        <col width="100px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Project</th>
                        </tr>
                        <tr>
                            <td>
                                <input type="checkbox" ref={ALL_CHECK} checked={CHECKED} onChange={AllCheckFunc} />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    className={"bpl-input-default"}
                                    name={"code"}
                                    value={SearchCondition.code}
                                    placeholder={"Project"}
                                    onChange={HandleSearchCondition}
                                />
                            </td>
                        </tr>
                    </thead>
                </table>
            </div>
            <div style={{ width: "170px", minHeight: "400px", height: "60vh", overflowY: "auto", overflowX: "hidden" }}>
                <table className={"bpl-table-default fixed has-pagination userAuthExternalTable-table seleced"}>
                    <colgroup>
                        <col width="40px" />
                        <col width="100px" />
                    </colgroup>
                    <tbody>
                        {ProjList?.map((rowData, index) => {
                            return (
                                <tr
                                    key={`UserAuthExternalSelectedList${index}`}
                                    onClick={() => HandleCheckbox(!rowData.checked, index)}
                                >
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={rowData.checked || false}
                                            onChange={({ target }) => HandleCheckbox(target.checked, index)}
                                        />
                                    </td>
                                    <td>{rowData.code}</td>
                                </tr>
                            );
                        })}
                        {ProjList.length < 1 && (
                            <>
                                <tr className={"non-clickable"}>
                                    <td colSpan={2}>No Selectable</td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default forwardRef(Projects);
